import { createFileRoute } from "@tanstack/react-router";
import { PlatformSchedulerPage } from "@/components/platform-scheduler-page";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/channels/instagram";

export const Route = createFileRoute(path)({
	component: InstagramScheduler,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "AgentReacher | Connect your AI agent to Instagram",
			description:
				"Schedule Instagram posts, Reels, and carousels with an AI agent. Captions, hashtags, and timing handled. Cancel anytime.",
		}),
});

function InstagramScheduler() {
	return (
		<PlatformSchedulerPage
			platform="instagram"
			platformLabel="Instagram"
			hero={{
				title: "Connect your AI agent to Instagram",
				description:
					"Connect AgentReacher to your AI assistant via MCP, then ask it to write captions, pick hashtags, and schedule feed posts, Reels, and carousels in your voice.",
			}}
		/>
	);
}
